// extracted by mini-css-extract-plugin
export default {"root":"AgreeTerm_root__Q-WZW"};